import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class Portal extends React.Component {
  static propTypes = {
    getParentElement: PropTypes.func,
    open: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    getParentElement: () => document.body,
    open: true,
    className: '',
  };

  componentDidMount() {
    this.createPortal();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currParent = this.props.getParentElement();
    const nextParent = nextProps.getParentElement();

    if (nextParent !== currParent) {
      currParent.removeChild(this.node);
      nextParent.appendChild(this.node);
    }

    if (nextProps.className !== this.props.className) {
      this.node.className = nextProps.className;
    }

    if (nextProps.open) {
      this.openPortal(nextProps);
    } else {
      this.closePortal();
    }
  }

  componentWillUnmount() {
    this.removePortal();
  }

  createPortal = () => {
    const { open, getParentElement, className } = this.props;

    this.node = document.createElement('div');
    this.node.className = className;

    const parent = getParentElement();
    parent.appendChild(this.node);

    if (open) {
      this.openPortal(this.props);
    }
  };

  removePortal = () => {
    const { getParentElement } = this.props;
    const parent = getParentElement();

    this.closePortal();
    parent.removeChild(this.node);
  };

  openPortal = props =>
    ReactDOM.unstable_renderSubtreeIntoContainer(this, props.children, this.node);

  closePortal = () => ReactDOM.unmountComponentAtNode(this.node);

  render() {
    return null;
  }
}
